import React from 'react';
import {BrandName} from "../../constants";

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="absolute left-0 w-[100vw] py-8 px-4 bg-gray-800 text-white">
            <div className="container mx-auto">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <div className="mb-4 md:mb-0">
                        <div className="flex items-center space-x-2">
                            <i className="fas fa-camera-retro text-2xl text-indigo-400"></i>
                            <h2 className="text-xl font-bold">{BrandName}</h2>
                        </div>
                        <p className="text-gray-400 mt-2 text-[12pt]">AI Image processing tools</p>
                    </div>
                    <div className="text-gray-400 text-sm">
                        &copy; {currentYear} {BrandName}. All Rights Reserved。
                    </div>
                </div>
            </div>
        </footer>
    );
};
